export default "__VITE_ASSET__BqzEKB06__"